import React from 'react';
import styled from 'styled-components';
import { _ } from '_locales';

import { secondaryColor } from '../app/apis';

const SubmitLabel = styled.label`
  display: none;
`;

const SubmitInput = styled.input`
  color: #FFFFFF;
  border-radius: 10px;
  border-width: 0px;
  font-size: 16px !important;
   
  width: 100%;
  height: 100%;
  text-shadow: #000000 0px 0px 1px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  background-color: ${(props) => props.secondaryColor};
  cursor: pointer;
  white-space: pre;
  display: block;

  &:focus {
    outline: none;
    box-shadow: 0 0 2px 2px #51a7e8;
  }
`;

const InputWrapper = styled.div`
  width: 148px;
  height: 48px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  margin: 40px 0;
`;

const SubmitButton = ({ type, value, style }) => (
  <InputWrapper tabIndex="-1">
    <SubmitLabel htmlFor="submit">{_('general.submit')}</SubmitLabel>
    <SubmitInput
      id="submit"
      type={type}
      tabIndex="0"
      value={value}
      style={style}
      aria-label="confirm to submit"
      aria-labelledby="confirm to submit"
      secondaryColor={secondaryColor}
    />
  </InputWrapper>
);

export default SubmitButton;
